import React from 'react';
import DOMPurify from 'dompurify';

function replacePlaceholders(html, replacements) {
  return html.replace(/{{(.*?)}}/g, (_, key) => replacements[key.trim()] || '');
}

export default function FeedbackCard({ email, onClose, t }) {
  const nickname = localStorage.getItem('nickname') || 'gebruiker';
  const rawHtml = email.highlightedBody || email.body;
  const interpolated = replacePlaceholders(rawHtml, { nickname });

  const cleanBody = DOMPurify.sanitize(interpolated, {
    ALLOWED_ATTR: ['class', 'href', 'style', 'src', 'title'],
  });

  const cleanSender = DOMPurify.sanitize(email.sender, {
    ALLOWED_ATTR: ['class', 'title', 'style'],
  });

  return (
    <div className="FeedbackCard bg-[#e2e8f0] text-[#2b3b4b] p-6 rounded-xl shadow-xl max-w-[640px] w-full sm:w-[90%] md:w-[80%] lg:w-[640px]">
      {/* Reason */}
      <div className="bg-red-100 border border-red-400 text-red-800 p-4 mb-4 rounded text-sm font-medium">
        <strong>{t.phishingReasonTitle}</strong>
        <br />
        {t.phishingReasonDesc}
      </div>

      {/* Email Content */}
      <div>
        <h3 className="pb-4 text-xl font-semibold break-words">{email.subject}</h3>

        <div className="pb-4 text-sm text-gray-600 space-y-1">
          <div className="flex flex-wrap items-center text-sm text-gray-600">
            <strong className="mr-1">From:</strong>
            {email.department && <span className="mr-2">{email.department}</span>}
            <span
              className="text-gray-500 break-words"
              dangerouslySetInnerHTML={{ __html: cleanSender }}
            />
          </div>

          <p>
            <strong>To:</strong> You
          </p>
        </div>

        <hr className="border-gray-300 w-full" />

        <div
          className="py-4 text-sm leading-relaxed break-words"
          dangerouslySetInnerHTML={{ __html: cleanBody }}
        />

        {email.footer?.trim() && (
          <>
            <hr className="border-gray-300 w-full" />
            <div
              className="text-xs text-gray-500 text-center pt-2 break-words"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(email.footer, {
                  ALLOWED_ATTR: ['class', 'href', 'style'],
                }),
              }}
            />
          </>
        )}
      </div>

      {/* Continue button */}
      <div className="mt-6 text-center">
        <button
          onClick={onClose}
          className="bg-[#00aca9] hover:bg-[#00918d] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-200 shadow-md hover:shadow-lg"
        >
          {t.continueButton}
        </button>
      </div>
    </div>
  );
}
